<template>
  <ProductDetailsNew v-if="isProductHighlightsEnabled" />
  <ProductDetailsOld v-else />
</template>

<script setup lang="ts">
import useExperiments from '~/stores/useExperimentsStore';
import ProductDetailsNew from './ProductDetailsNew.vue';
import ProductDetailsOld from './ProductDetailsOld.vue';

const {
  experimentFlags: { isProductHighlightsEnabled },
} = useExperiments();
</script>
